import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { AreaMapOfSpillDto, UomDto, PartyDto, TerrainDto, AppConfigurationDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { IncidentDto } from '@cradua/data';

@Component({
  selector: 'cradua-area-map-of-spill',
  templateUrl: './area-map-of-spill.component.html',
  styleUrls: ['./area-map-of-spill.component.scss']
})
export class AreaMapOfSpillComponent implements OnInit {

  @Input() incident:IncidentDto[];
  @Input() appConfig: AppConfigurationDto[];
  @Input() selectedIncidentId: IncidentDto;
  @Output() deleteAreaOfSpillEvent = new EventEmitter<any>()
  @Output() emitAreaOfSpill = new EventEmitter<AreaMapOfSpillDto[]>()

  areaOfSpillForm:FormGroup;
  areaOfSpillFormArray:FormGroup;
  filteredDelete: Array<any> =[];
  selectedAreaOfSpill: any;
  selectedIndex = null;
  selectedId: any;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.createAreaOfSpillForm();
    if(this.selectedIncidentId != null && this.selectedIncidentId.areaofspills?.length){
      this.setAreaOfSpill(this.selectedIncidentId.areaofspills);
    }
  }

  createAreaOfSpillForm(){
    this.areaOfSpillForm = this.fb.group({
      LinkageId: [''],
      Date:[''],
      Remarks:[''],
      Url:[''],
      AreaMapSpillDescription:[''],
      SerialNo:[this.selectedIncidentId?.id],
      id: null,
      // IncidentNotificationId: [this.selectedIncidentId.IncidentNotificationId],
      });
      this.areaOfSpillFormArray = this.fb.group({ AreaOfSpills: this.fb.array([])
        });

  }


  onPopulateUrl() {
    const selectedValue = this.areaOfSpillForm.value;
    const appConfig = this.appConfig.find(map => map.type === 'MyMap');
    const urlMap = appConfig?.leftvalue + selectedValue?.LinkageId + appConfig?.rightvalue;
    this.areaOfSpillForm.patchValue({Url: urlMap});
  }

   get getAreaOfSpillFormArray(){
    return this.areaOfSpillFormArray.get('AreaOfSpills') as FormArray;
   }
  setAreaOfSpill(areaOfSpills: AreaMapOfSpillDto[]) {
    areaOfSpills.forEach(areaOfSpill => {
      this.getAreaOfSpillFormArray.push(this.fb.group({
        LinkageId: areaOfSpill.LinkageId,
        Date:areaOfSpill.Date,
        Remarks:areaOfSpill.Remarks,
        Url: areaOfSpill.Url,
        AreaMapSpillDescription: areaOfSpill.AreaMapSpillDescription,
        id: areaOfSpill.id,
        SerialNo: areaOfSpill.SerialNo,
      }))
    })

  }


  // method to add AreaOfSpill
  addAreaOfSpill(value: AreaMapOfSpillDto) {
    const control  = this.areaOfSpillFormArray.controls.AreaOfSpills as FormArray;
    control.insert(0,
          this.fb.group({
            LinkageId: value.LinkageId,
            Date:value.Date,
            Remarks:value.Remarks,
            Url: value.Url,
            AreaMapSpillDescription: value.AreaMapSpillDescription,
            SerialNo: this.selectedIncidentId.id,

          })
       );
  }

  selectAreaOfSpill(value) {}

   // method to delete areaofimpact from arrary list
  deleteAreaOfSpill(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {

  this.getAreaOfSpillFormArray.removeAt(index);
  for ( let i = 0; i < this.selectedIncidentId.areaofspills.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.selectedIncidentId.areaofspills[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }


  onAddAreaOfSpill(value: AreaMapOfSpillDto) {

    if(this.areaOfSpillForm.invalid) {
      return Swal.fire(
         'Warning!',
         'Please, you cannot add blank field',
         'warning'
       );
       }
       if(this.selectedIndex != null) {

         this.areaOfSpillFormArray.get('AreaOfSpills')['controls'][this.selectedIndex].patchValue({
           ...value,
           Date: value.Date != null ? this.dateTransformation(value.Date) : null,
          });
       } else {
         this.addAreaOfSpill(value);
       }
       this.selectedIndex = null;
     this.areaOfSpillForm.reset()
  }





  onEdit(index, value: AreaMapOfSpillDto) {
    this.selectedIndex = index;
    this.areaOfSpillForm.patchValue({
      ...value,
      Date: value.Date != null ? this.dateTransformation(value.Date) : null,
      });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.areaOfSpillForm.reset();
  }

  onSubmit() {
    this.emitAreaOfSpill.emit(this.areaOfSpillFormArray.value.AreaOfSpills);
  }

  protected findById = <T>(id: string) =>
  (fieldName: T) => fieldName["id"] === id;


  dateTransformation(date) {
    let d = new Date(date);
    let day = '' + d.getDate();
    let month = '' + (d.getMonth() + 1);
    let year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }

    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

}
